import { FC } from 'react';
// i18next
import { Trans, useTranslation } from 'react-i18next';

const PoweredBy:FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className="mb-4">
      <h3 className="font-semibold text-center">
        <Trans
          t={t}
          components={{
            span: <span className="font-bold" style={{ fontFamily: 'Montserrat' }} />,
            span2: <span style={{ color: '#ff9100' }} />,
          }}
          i18nKey="quiz.countdownPage.poweredBy"
        />
      </h3>
    </div>
  );
}

export default PoweredBy;
